// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Widget/Punctuality/ChartTooltip" (19022:460108). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const widgetPunctualityCharttooltipContract = {
    component: 'Widget/Punctuality/ChartTooltip',
    nodeId: '19022:460108',
    section: 'Punctuality · Components',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        {
            component: 'Widget/Punctuality/ChartTooltip/Direction',
            variants: [
                'direction=arrivals, hour=current',
                'direction=arrivals, hour=forecast',
                'direction=arrivals, hour=past',
                'direction=departures, hour=current',
                'direction=departures, hour=forecast',
                'direction=departures, hour=past',
            ],
        },
        {
            component: 'Widget/Punctuality/ChartTooltip/FlightRow',
            variants: ['user=external', 'user=finavia'],
        },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: ['S:0fa036ddc0a173a340137517ff39c483dfbade3d,'],
    props: {
        hour: { kind: 'enum', values: ['past', 'current', 'forecast'] },
        user: { kind: 'enum', values: ['finavia', 'external'] },
    },
    variants: {
        'hour=current, user=external': {
            container:
                'bg-background-elevation rounded-common px-s py-s gap-xs w-[17.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-border-subtle',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                title: 'text-content-muted text-left',
                departures: 'gap-2xs items-start',
                divider: 'bg-border-subtle h-[0.0625rem]',
                arrivals: 'gap-2xs items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/Direction',
                    variants: [
                        'direction=arrivals, hour=current',
                        'direction=departures, hour=current',
                    ],
                },
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=external'],
                },
            ],
        },
        'hour=current, user=finavia': {
            container:
                'bg-background-elevation rounded-common px-s py-s gap-xs w-[17.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-border-subtle',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                title: 'text-content-muted text-left',
                departures: 'gap-2xs items-start',
                divider: 'bg-border-subtle h-[0.0625rem]',
                arrivals: 'gap-2xs items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/Direction',
                    variants: [
                        'direction=arrivals, hour=current',
                        'direction=departures, hour=current',
                    ],
                },
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'hour=forecast, user=external': {
            container:
                'bg-background-elevation rounded-common px-s py-s gap-xs w-[17.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-border-subtle',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                title: 'text-content-muted text-left',
                departures: 'gap-2xs items-start',
                divider: 'bg-border-subtle h-[0.0625rem]',
                arrivals: 'gap-2xs items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/Direction',
                    variants: [
                        'direction=arrivals, hour=forecast',
                        'direction=departures, hour=forecast',
                    ],
                },
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=external'],
                },
            ],
        },
        'hour=forecast, user=finavia': {
            container:
                'bg-background-elevation rounded-common px-s py-s gap-xs w-[17.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-border-subtle',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                title: 'text-content-muted text-left',
                departures: 'gap-2xs items-start',
                divider: 'bg-border-subtle h-[0.0625rem]',
                arrivals: 'gap-2xs items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/Direction',
                    variants: [
                        'direction=arrivals, hour=forecast',
                        'direction=departures, hour=forecast',
                    ],
                },
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
        'hour=past, user=external': {
            container:
                'bg-background-elevation rounded-common px-s py-s gap-xs w-[17.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-border-subtle',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                title: 'text-content-muted text-left',
                departures: 'gap-2xs items-start',
                divider: 'bg-border-subtle h-[0.0625rem]',
                arrivals: 'gap-2xs items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/Direction',
                    variants: ['direction=arrivals, hour=past', 'direction=departures, hour=past'],
                },
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=external'],
                },
            ],
        },
        'hour=past, user=finavia': {
            container:
                'bg-background-elevation rounded-common px-s py-s gap-xs w-[17.5rem] items-start',
            label: 'text-content-muted text-left',
            icon: 'text-border-subtle',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                title: 'text-content-muted text-left',
                departures: 'gap-2xs items-start',
                divider: 'bg-border-subtle h-[0.0625rem]',
                arrivals: 'gap-2xs items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'Widget/Punctuality/ChartTooltip/Direction',
                    variants: ['direction=arrivals, hour=past', 'direction=departures, hour=past'],
                },
                {
                    component: 'Widget/Punctuality/ChartTooltip/FlightRow',
                    variants: ['user=finavia'],
                },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
